import { Component, Input, OnInit, inject } from '@angular/core';
import {RouteTaskView} from "../route-task-view.model";
import {RouteVisualizationService} from "../services/route-visualization.service";
import {EmployeeView} from "planner-shared";
import {Observable} from "rxjs";
import {TaskColorService} from "../../../shared/services/task-color/task-color.service";
import {DelayLevel} from "../../models/delay-level.model";

@Component({
    selector: 'app-route-planning-pdf-view',
    templateUrl: './route-planning-pdf-view.component.html',
    styleUrls: ['./route-planning-pdf-view.component.scss'],
    standalone: false
})
export class RoutePlanningPdfViewComponent implements OnInit {
    private readonly routeVisualizationService = inject(RouteVisualizationService);
    private readonly taskColorService = inject(TaskColorService);


    @Input() public routeTasks: RouteTaskView[];
    @Input() public employee: EmployeeView;
    @Input() public showFreeTimeBetweenTasksFeature: Observable<boolean>;
    @Input() public showTaskDelayHighlight: boolean;

    protected readonly DelayLevel = DelayLevel;

    ngOnInit() {
        this.taskColorService.getTaskColors().forEach(coloredTask => {
            const uncoloredTask = this.routeTasks.find(routeTask => routeTask.taskId === coloredTask.taskId);
            if (uncoloredTask) {
                uncoloredTask.color = coloredTask.color;
            }
        });
    }

    public getRideSharingCompanionsName(routeTask: RouteTaskView): string {
        return this.routeVisualizationService.getRideSharingCompanionsName(routeTask);
    }
}
